module.exports = __webpack_public_path__ + "static/media/menu.e01c07b7.svg";